import React, { useState } from 'react';
import GlassSurface from './GlassSurface';
import { motion } from 'framer-motion';
import { hapticLight } from '../utils/haptics';

const GlassButton = ({
  children,
  onClick,
  href,
  width = 200,
  height = 54,
  borderRadius,
  className = '',
  glassProps = {},
}) => {
  const [tilt, setTilt] = useState({ x: 0, y: 0 });

  const handleClick = (e) => {
    hapticLight();
    if (onClick) onClick(e);
  };

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width;
    const py = (e.clientY - rect.top) / rect.height;
    const rotateX = (0.5 - py) * 8; // max 3D tilt
    const rotateY = (px - 0.5) * 8;
    setTilt({ x: rotateY, y: rotateX });
  };

  const handleMouseLeave = () => {
    setTilt({ x: 0, y: 0 });
  };

  const computedRadius =
    borderRadius ?? (typeof height === 'number' ? Math.max(12, Math.floor(height / 2)) : 9999);
  const content = (
    <GlassSurface
      width={width}
      height={height}
      borderRadius={computedRadius}
      className={`glass-outline ${className}`}
      backgroundOpacity={0.02}
      saturation={1.8}
      displace={10}
      distortionScale={-160}
      brightness={70}
      opacity={0.78}
      mixBlendMode="screen"
      {...glassProps}
    >
      <div className="glass-liquid" aria-hidden="true" />
      <div className="glass-sheen" aria-hidden="true" />
      <span className="px-7 py-3 text-white font-medium glass-label">{children}</span>
    </GlassSurface>
  );

  if (href) {
    return (
      <motion.a
        href={href}
        target={href?.startsWith('http') ? '_blank' : undefined}
        rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
        whileHover={{ scale: 1.06, y: -3 }}
        animate={{ 
          rotateX: tilt.y, 
          rotateY: tilt.x,
        }}
        transition={{ type: 'spring', stiffness: 400, damping: 10 }}
        onClick={handleClick}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        className={`inline-block cursor-pointer relative glass-button-wrapper ${className}`}
        style={{
          perspective: '700px',
          transformStyle: 'preserve-3d',
          willChange: 'transform',
        }}
      >
        {content}
        <span className="glass-bottom-glow" aria-hidden="true" />
      </motion.a>
    );
  }

  return (
    <motion.button
      type="button"
      onClick={handleClick}
      whileHover={{ scale: 1.06, y: -3 }}
      animate={{ 
        rotateX: tilt.y, 
        rotateY: tilt.x,
      }}
      transition={{ type: 'spring', stiffness: 400, damping: 10 }}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      className={`inline-block cursor-pointer relative glass-button-wrapper ${className}`}
      style={{
        background: 'transparent',
        perspective: '700px',
        transformStyle: 'preserve-3d',
        willChange: 'transform',
      }}
    >
      {content}
      <span className="glass-bottom-glow" aria-hidden="true" />
    </motion.button>
  );
};

export default GlassButton;


